import { buildLoader } from '../util/GenericLoader';
import { fetchExportsAction } from '../../redux/actions/exports';

export default buildLoader(fetchExportsAction);
